import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _class, _class2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import Modal from '@mui/material/Modal';
import { injectIntl, defineMessages } from 'react-intl';
import _ from 'lodash';
import isLoggedIn from '../../helpers/checkAuth';
import RestrictedAccessModal from '../RestrictedAccessModal/RestrictedAccessModal';
import Link from '../Link';
import SkholeIcon11White from '../statelessComponents/Icons/SkholeIcon11White';
import SkholeIcon11 from '../statelessComponents/Icons/SkholeIcon11';
import s from './QuizzesListItem.scss';
import { isUserFromWhitelabeledOrganization, userSkillEvaluationEnabled } from '../../helpers';
import intlPropTypes from '../../constants/intlPropTypes';
var messages = defineMessages({
  finishQuizTitle: {
    id: "QuizListItem.finishTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Finished quiz"
    }]
  },
  notStartedQuizTitle: {
    id: "QuizListItem.notStartedTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Not started quiz"
    }]
  },
  notAvailableOffline: {
    id: "QuizListItem.notAvailableOffline",
    defaultMessage: [{
      "type": 0,
      "value": "Not available offline"
    }]
  },
  notAvailableInOfflineMode: {
    id: "QuizListItem.notAvailableInOfflineMode",
    defaultMessage: [{
      "type": 0,
      "value": "Not available in offline mode"
    }]
  },
  archived: {
    id: "QuizListItem.archived",
    defaultMessage: [{
      "type": 0,
      "value": "Archived"
    }]
  }
});
var QuizzesListItem = (_dec = withStyles(s), _dec2 = connect(function (state) {
  return {
    auth: state.auth,
    lang: state.intl.locale,
    offline: state.online.offline
  };
}), injectIntl(_class = _dec(_class = _dec2(_class = (_class2 = /*#__PURE__*/function (_Component) {
  _inherits(QuizzesListItem, _Component);
  var _super = _createSuper(QuizzesListItem);
  function QuizzesListItem() {
    var _this;
    _classCallCheck(this, QuizzesListItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isRestrictedAccessModalOpened: false
    });
    _defineProperty(_assertThisInitialized(_this), "hasAccess", function () {
      var _this$props = _this.props,
        auth = _this$props.auth,
        course = _this$props.course;
      return isLoggedIn(auth) && course.isAvailable;
    });
    _defineProperty(_assertThisInitialized(_this), "checkAuth", function (event) {
      if (_this.hasAccess()) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      _this.setState({
        isRestrictedAccessModalOpened: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeRestrictedAccessModal", function () {
      _this.setState({
        isRestrictedAccessModalOpened: false
      });
    });
    return _this;
  }
  _createClass(QuizzesListItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        item = _this$props2.item,
        auth = _this$props2.auth,
        course = _this$props2.course,
        active = _this$props2.active,
        formatMessage = _this$props2.intl.formatMessage,
        isCompleted = _this$props2.isCompleted,
        offline = _this$props2.offline,
        disabled = _this$props2.disabled;
      var isRestrictedAccessModalOpened = this.state.isRestrictedAccessModalOpened;
      var completedSectionItemsNumber = course.completedLessons + course.completedQuizzes;
      var isWhitelabeled = isUserFromWhitelabeledOrganization(auth);
      var isUserSkillEvaluationEnabled = userSkillEvaluationEnabled(auth);
      var showEvaluationModal = (!isWhitelabeled || isUserSkillEvaluationEnabled) && !_.get(course, 'isUserSkillEvaluated') && !course.progress && !completedSectionItemsNumber && !offline && isLoggedIn(auth);
      var listItem = /*#__PURE__*/_jsx(ListItem, {
        "data-test-id": "ICbU7WVGlauVeGkjMFqBx",
        className: classNames(s.quizListItem, active ? s.active : undefined, _defineProperty({}, s.archived, !!item.removed)),
        component: this.hasAccess() ? Link : 'div',
        to: "/courses/".concat(course.slug, "/quizzes/").concat(item._id).concat(showEvaluationModal ? '?showEvaluationModal' : ''),
        disabled: offline || disabled,
        onClick: this.checkAuth,
        button: true
      }, void 0, /*#__PURE__*/_jsx(ListItemIcon, {
        classes: {
          root: s.quizListItemRoot
        }
      }, void 0, active ? /*#__PURE__*/_jsx(SkholeIcon11White, {
        color: "#fff",
        className: s.startQuizIcon
      }) : /*#__PURE__*/_jsx(SkholeIcon11, {
        className: s.startQuizIcon
      })), /*#__PURE__*/_jsx(ListItemText, {
        primary: item.name,
        secondary: /*#__PURE__*/React.createElement(React.Fragment, null, offline && /*#__PURE__*/_jsx("div", {}, void 0, formatMessage(messages.notAvailableOffline)), !!item.removed && /*#__PURE__*/_jsx("div", {}, void 0, formatMessage(messages.archived))),
        classes: {
          root: s.quizTitleTextWrapper,
          primary: s.quizTitleTextPrimary,
          secondary: s.quizTitleTextSecondary
        }
      }), /*#__PURE__*/_jsx(ListItemSecondaryAction, {
        className: s.secondaryAction
      }, void 0, isCompleted && isLoggedIn(auth) && /*#__PURE__*/_jsx(Tooltip, {
        id: "tooltip-finished",
        title: formatMessage(messages.finishQuizTitle)
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.completedIcon
      })), isCompleted === false && isLoggedIn(auth) && /*#__PURE__*/_jsx(Tooltip, {
        id: "tooltip-not-started",
        title: formatMessage(messages.notStartedQuizTitle)
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.notCompletedIcon
      }))));
      if (offline) {
        listItem = /*#__PURE__*/_jsx(Tooltip, {
          title: formatMessage(messages.notAvailableOffline)
        }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, listItem));
      }
      return /*#__PURE__*/_jsx("div", {}, void 0, listItem, /*#__PURE__*/_jsx(Modal, {
        open: isRestrictedAccessModalOpened,
        onClose: this.closeRestrictedAccessModal
      }, void 0, /*#__PURE__*/_jsx(RestrictedAccessModal, {
        onClose: this.closeRestrictedAccessModal
      })));
    }
  }]);
  return QuizzesListItem;
}(Component), _defineProperty(_class2, "defaultProps", {
  active: false,
  isCompleted: undefined,
  disabled: false
}), _class2)) || _class) || _class) || _class);
export { QuizzesListItem as default };